"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALIDATE_USER_TOKEN = exports.UPLOAD_USER_VIRTUAL_BACKGROUND = exports.SAVE_USER_VIRTUAL_BACKGROUND = exports.RESET_USER_VIRTUAL_BACKGROUND = exports.GET_USER_FROM_SESSION = exports.DELETE_USER_VIRTUAL_BACKGROUND = void 0;
var GET_USER_FROM_SESSION = exports.GET_USER_FROM_SESSION = 'GET_USER_FROM_SESSION';
var VALIDATE_USER_TOKEN = exports.VALIDATE_USER_TOKEN = 'VALIDATE_USER_TOKEN';
var UPLOAD_USER_VIRTUAL_BACKGROUND = exports.UPLOAD_USER_VIRTUAL_BACKGROUND = 'UPLOAD_USER_VIRTUAL_BACKGROUND';
var DELETE_USER_VIRTUAL_BACKGROUND = exports.DELETE_USER_VIRTUAL_BACKGROUND = 'DELETE_USER_VIRTUAL_BACKGROUND';
var RESET_USER_VIRTUAL_BACKGROUND = exports.RESET_USER_VIRTUAL_BACKGROUND = 'RESET_USER_VIRTUAL_BACKGROUND';
var SAVE_USER_VIRTUAL_BACKGROUND = exports.SAVE_USER_VIRTUAL_BACKGROUND = 'SAVE_USER_VIRTUAL_BACKGROUND';